import { Component, OnInit, Output, EventEmitter, Input,ViewChild,NgZone} from '@angular/core';
import {MatTableModule} from '@angular/material/table';
import { FormGroup, FormControl, Validators,FormArray } from '@angular/forms';
import { MatDialog} from '@angular/material/dialog';
import { ModalProcedimientoComponent } from 'src/app/components/modal-procedimiento-asis/modal-procedimiento.component';
import { DataService } from 'src/app/services/data.service';
import { NotifierService } from 'angular-notifier';
import { Proceso, Procedimiento } from 'src/app/interfaces/interfaces';
import{ ConfirmComponent} from 'src/app/components/shared/confirm/confirm.component';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { NgIf } from '@angular/common';






@Component({
  selector: 'app-costeo-proceso',
  templateUrl: './costeo-proceso.component.html',
  styleUrls: ['./costeo-proceso.component.css']
})
export class CosteoProcesoComponent implements OnInit {
  costeoError = false;
  subiendoCosteo = false;
  formProcesos: FormGroup;
  formEdita:FormGroup;
  abrirModal= false;
//Evento de salida para el boton de siguiente, ventana costeo
@Output() botonAgregarProcedimiento = new EventEmitter<boolean>();
@Input('id_iniciatva') id_iniciativa:string;
@Input('id_proceso') id_proceso:number;
//Variable para cargar la tabla de procedimientos
tablaProcedimientos: Procedimiento[]=[];
tablaProcedimientosToBe: Procedimiento[]=[];
tabla: Procedimiento[]=[];
@ViewChild(ModalProcedimientoComponent) editUserComponent: ModalProcedimientoComponent;
@Output() propagar = new EventEmitter<string>();


  constructor(public dialog:MatDialog, 
              private dataService: DataService,
              private notifier: NotifierService,
              private zone: NgZone,
              private router: Router,
    ) { }

  ngOnInit(): void {
    if(this.id_proceso)
    {
      this.verDetallesProceso(this.id_proceso);
      this.recargarTabla(this.id_proceso);
    }

    this.formProcesos= new FormGroup({
      id_proceso:new FormControl(''),
      id_iniciativa: new FormControl(''),
      nombre_proceso: new FormControl(''),
      procedimiento_proceso: new FormControl(''),
      duenio_proceso: new FormControl(''),
      tramitesExternosASIS_proceso: new FormControl(''),
      tramitesInternosASIS_proceso: new FormControl(''),
      tramitesExternosTOBE_proceso: new FormControl(''),
      tramitesInternosTOBE_proceso: new FormControl(''),
      hojasImpresasASIS_proceso : new FormControl(''),
      hojasImpresasTOBE_proceso : new FormControl(''),
      kmRecorridosASIS_Proceso: new FormControl(''),
      kmRecorridosTOBE_Proceso: new FormControl('')

    })

    this.formEdita= new FormGroup({
      rol_procesoDetalle: new FormControl(''),
      puesto_procesoDetalle: new FormControl(''),
      tiempoOperacion_procesoDetalle: new FormControl(''),
      tiempoEspera_procesoDetalle: new FormControl(''),
      nivelTabular_procesoDetalle: new FormControl(''),
      numParticipantes_procesoDetalle: new FormControl(''),
      tipoProceso_procesoDetalle: new FormControl(''),
      id_proceso : new FormControl(''),
    })

    //Agregamos el valor de la iniciativa
    this.formProcesos.patchValue({
      id_iniciativa:this.id_iniciativa
    })

  }

  onSubmit()
  {
      //Verificar si las listas no vienen vacias
      if(this.tablaProcedimientos.length > 0 || this.tablaProcedimientosToBe.length > 0)
      {
        //Mandamos el proceso por si hubo modificaciones
        this.dataService.insertarUpdateProceso(this.formProcesos.value,[]).subscribe(res=>{
          if (res['errorMessage']) 
          {
            this.notifier.notify('error',
            'Ha ocurrido un error al intentar guardar la iniciativa. Revisa tu conexión de red en inténtalo de nuevo más tarde.');
          } 
          else
          {
            //Mapeamos el proceso
            this.id_proceso=res['objData']['id_proceso'];
             //Agregamos los valores de la lista de procedimientosToBe a la lista de procedimientos
             if(this.tablaProcedimientosToBe.length >= 1)
             {
               for(let numero of this.tablaProcedimientosToBe)
               {
                   this.tablaProcedimientos.push(numero);
               }
             }
             //Le agrego el nuevo id de proceso a la lista
             for(var i = 0; i < this.tablaProcedimientos.length; i++)
             {
               this.tablaProcedimientos[i].id_proceso=this.id_proceso;
             }
             //Enviamos a la base de datos la lista
             this.dataService.insertarUpdateListDetalleProceso(this.tablaProcedimientos).subscribe(res => {
                if (res['errorMessage']) {
                  this.notifier.notify('error',
                  'Ha ocurrido un error al intentar guardar la iniciativa. Revisa tu conexión de red en inténtalo de nuevo más tarde.');
                } else {
                  this.notifier.notify('success', 'Iniciativa registrada correctamente.');
                  this.zone.run(() => this.router.navigate(['/mis-iniciativas']));
                }
              });
          }
        });
      }
      //Si vienen vacias, solo enviamos el form
      else
      {
        this.dataService.insertarUpdateProceso(this.formProcesos.value,[]).subscribe(res=>{
          if (res['errorMessage']) 
          {
            this.notifier.notify('error',
            'Ha ocurrido un error al intentar guardar la iniciativa. Revisa tu conexión de red en inténtalo de nuevo más tarde.');
          } 
          else{
                //Si la lista inicial si trae elementos lo borramos de la base
                if(this.tabla.length >=1 )
                {
                  //Borramos de base
                  this.dataService.deleteDetalleProcesoByProceso(this.id_proceso).subscribe(res=>{
                    if(res['errorMessage']){
                      this.notifier.notify('error','Ha ocurrido un error al intentar guardar la iniciativa. Revisa tu conexión de red en inténtalo de nuevo más tarde.'); 
                    }

                  });

                }

                this.notifier.notify('success', 'Iniciativa registrada correctamente.');
                this.zone.run(() => this.router.navigate(['/mis-iniciativas']));
          }
        });
      }//cierre del else 



    
  }//cierre del método

  //Método para editar el modal del proceso AsIs
  editarProcedimientoAsIs(id:number)
  {
    //Convertimos el valor de la tabla en una cadena JSON y la enviamos al modal
    let cadena=JSON.stringify(this.tablaProcedimientos[id]);
    const dialogRef = this.dialog.open(ModalProcedimientoComponent,{data:{data:`${cadena}`, titulo:`Procedimiento Actual (As-Is)`},disableClose:true, height: '580px',
    width: '800px'},);
    dialogRef.afterClosed().subscribe(data => {
      if(data==false)
      {
      }
      else{
        this.tablaProcedimientos[id]=data;
        //Mapeamos el idProceso y tipo
        data['id_proceso']=this.id_proceso;
        data['tipoProceso_procesoDetalle']=0;
        //this.tablaProcedimientos.push(data);
        //Recargamos la tabla
        //this.recargarTabla(this.id_proceso);
      }//Cerrar el else
    //Cerrar ventana modal
   });
  }


  //Método para editar el modal del proceso AsIs
  editarProcedimientoToBe(id:number)
  {
    //Convertimos el valor de la tabla en una cadena JSON y la enviamos al modal
    let cadena=JSON.stringify(this.tablaProcedimientosToBe[id]);
    const dialogRef = this.dialog.open(ModalProcedimientoComponent,{data:{data:`${cadena}`, titulo:`Procedimiento Propuesto (To-Be)`},disableClose:true, height: '580px',
    width: '800px'},);
    dialogRef.afterClosed().subscribe(data => {
      if(data==false)
      {
      }
      else{
        this.tablaProcedimientosToBe[id]=data;
        //Mapeamos el idProceso y tipo
        data['id_proceso']=this.id_proceso;
        data['tipoProceso_procesoDetalle']=1;
        //this.tablaProcedimientos.push(data);
        //Recargamos la tabla
        //this.recargarTabla(this.id_proceso);
      }//Cerrar el else
    //Cerrar ventana modal
   });
  }

  //Eliminar los registros del proceso
  eliminarProcedimientoAsIs(id:number)
  {
    this.tablaProcedimientos.splice(id,1);
  }

  eliminarProcedimientoToBe(id:number)
  {
    this.tablaProcedimientosToBe.splice(id,1);
  }

  //Abrir modal para agregar los procedimientos del proceso ASIS
  abrirModalProcedimientoAsIs()
  { 
    const dialogRef = this.dialog.open(ModalProcedimientoComponent,{data:{titulo:`Procedimiento Actual (As-Is)`},disableClose:true, height: '580px',
    width: '800px'});
    dialogRef.afterClosed().subscribe(data => {
      if(data==false)
      {
      }
      else{
        //Mapeamos el idProceso y tipo
        data['id_proceso']=this.id_proceso;
        data['tipoProceso_procesoDetalle']=0;
        this.tablaProcedimientos.push(data);
        //Recargamos la tabla
        //this.recargarTabla(this.id_proceso);
      }//Cerrar el else
    //Cerrar ventana modal
   });
 }


 //Abrir modal para agregar los procedimientos del proceso ASIS
 abrirModalProcedimientoToBe()
 { 
   const dialogRef = this.dialog.open(ModalProcedimientoComponent,{data:{titulo:`Procedimiento Propuesto (To-Be)`},disableClose:true, height: '580px',
   width: '800px'});
   dialogRef.afterClosed().subscribe(data => {
     if(data==false)
     {
     }
     else{
       //Mapeamos el idProceso y tipo
       data['id_proceso']=this.id_proceso;
       data['tipoProceso_procesoDetalle']=1;
       this.tablaProcedimientosToBe.push(data);
       //Recargamos la tabla
       //this.recargarTabla(this.id_proceso);
     }//Cerrar el else
   //Cerrar ventana modal
  });
}

  descargarArchivoEjemplo(archivo:string)
  {
    this.dataService.descargarArchivoCosteo().subscribe(res => {
      // Este es necesario para crear un objeto blob con el tipo de archivo
      // puesto explicitamente, de lo contrario solo Chrome funcionara correctamente
      let newBlob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      // IE no permite objetos blob directamente en el atributo href de un link
      // en su lugar hay que usar msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      const data = window.URL.createObjectURL(newBlob);

       let link = document.createElement('a');
      
      link.download = archivo;
      // Esta linea es necesaria desde que link.click() ya no funciona en las ultimas versiones de firefox
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

      setTimeout(function () {
        // Para Firefox es necesario retrasar la revocacion del objeto ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });



  }

  onFileChange(event: any, nombreArchivo: string) 
  {
    if (event.target.files && event.target.files.length) 
    {
      const [file] = event.target.files;

      //Verificamos que ya exista un proceso
      if(this.id_proceso)
      {
        this.dataService.subirArchivoCosteo(file,parseInt(this.id_iniciativa),this.id_proceso).subscribe( 
          (data: string) => {
            if (data['objData']) 
            {
              let infoProceso:Proceso=data['objData']['oProcesos']
                  this.formProcesos.patchValue({
                    id_proceso:this.id_proceso,
                    nombre_proceso:infoProceso.nombre_proceso,
                    procedimiento_proceso:infoProceso.procedimiento_proceso,
                    duenio_proceso:infoProceso.duenio_proceso,
                    tramitesExternosASIS_proceso:infoProceso.tramitesExternosASIS_proceso,
                    tramitesExternosTOBE_proceso:infoProceso.tramitesExternosTOBE_proceso,
                    tramitesInternosASIS_proceso:infoProceso.tramitesInternosASIS_proceso,
                    tramitesInternosTOBE_proceso:infoProceso.tramitesInternosTOBE_proceso,
                    hojasImpresasASIS_proceso:infoProceso.hojasImpresasASIS_proceso,
                    hojasImpresasTOBE_proceso:infoProceso.hojasImpresasTOBE_proceso,
                    kmRecorridosASIS_Proceso:infoProceso.kmRecorridosASIS_Proceso,
                    kmRecorridosTOBE_Proceso:infoProceso.kmRecorridosTOBE_Proceso,
                    id_iniciativa:parseInt(this.id_iniciativa)
                  })
                  
                  if(data['objData']['listDetalleProcesos'])
                  {
                    //Agregamos en la lista los procedimientos
                    this.tabla= data['objData']['listDetalleProcesos'];
                    for(let numero of this.tabla)
                    {
                      if(numero.tipoProceso_procesoDetalle==1)
                      { 
                          this.tablaProcedimientosToBe.push(numero);
                      }
                      else{
                        this.tablaProcedimientos.push(numero);
                      }
                    }
                  }//Cierre del if de la lista
            }
            else{
              let mensaje=data['errorMessage'];
              this.notifier.notify('error',mensaje);
            }
            
          },
          error => {
            console.error(error); 
          });
      }//Cierre del if
      else{
        //Obtenemos el proceso
        this.dataService.insertarUpdateProceso(this.formProcesos.value,[]).subscribe(res=>{
          if(res['objData'])
          {
            this.id_proceso=res['objData']['id_proceso'];
            this.dataService.subirArchivoCosteo(file,parseInt(this.id_iniciativa),this.id_proceso).subscribe( 
              (data: string) => {
                if (data['objData']) 
                {
                  let infoProceso:Proceso=data['objData']['oProcesos']
                  this.formProcesos.patchValue({
                    id_proceso:this.id_proceso,
                    nombre_proceso:infoProceso.nombre_proceso,
                    procedimiento_proceso:infoProceso.procedimiento_proceso,
                    duenio_proceso:infoProceso.duenio_proceso,
                    tramitesExternosASIS_proceso:infoProceso.tramitesExternosASIS_proceso,
                    tramitesExternosTOBE_proceso:infoProceso.tramitesExternosTOBE_proceso,
                    tramitesInternosASIS_proceso:infoProceso.tramitesInternosASIS_proceso,
                    tramitesInternosTOBE_proceso:infoProceso.tramitesInternosTOBE_proceso,
                    hojasImpresasASIS_proceso:infoProceso.hojasImpresasASIS_proceso,
                    hojasImpresasTOBE_proceso:infoProceso.hojasImpresasTOBE_proceso,
                    kmRecorridosASIS_Proceso:infoProceso.kmRecorridosASIS_Proceso,
                    kmRecorridosTOBE_Proceso:infoProceso.kmRecorridosTOBE_Proceso,
                    id_iniciativa:parseInt(this.id_iniciativa)
                  })


                  if(data['objData']['listDetalleProcesos'])
                  {
                    //Agregamos en la lista los procedimientos
                    this.tabla= data['objData']['listDetalleProcesos'];
                    for(let numero of this.tabla)
                    {
                      if(numero.tipoProceso_procesoDetalle==1)
                      { 
                          this.tablaProcedimientosToBe.push(numero);
                      }
                      else{
                        this.tablaProcedimientos.push(numero);
                      }
                    }
                  }//Cierre del if de la lista
                  
                }else{
                  let mensaje=data['errorMessage'];
                  this.notifier.notify('error',mensaje);
                }
                },
              error => {
                console.error(error); 
              });
          }
        });

      }

     
    }

  }

  verDetallesProceso(id_proceso:number)
  {
    this.dataService.detalleProceso(id_proceso,0).subscribe(data => {
      if (data['objData']) 
      {
        let infoProceso: Proceso = data['objData'];
        this.formProcesos.patchValue({
          id_proceso:this.id_proceso,
          nombre_proceso:infoProceso.nombre_proceso,
          procedimiento_proceso:infoProceso.procedimiento_proceso,
          duenio_proceso:infoProceso.duenio_proceso,
          tramitesExternosASIS_proceso:infoProceso.tramitesExternosASIS_proceso,
          tramitesExternosTOBE_proceso:infoProceso.tramitesExternosTOBE_proceso,
          tramitesInternosASIS_proceso:infoProceso.tramitesInternosASIS_proceso,
          tramitesInternosTOBE_proceso:infoProceso.tramitesInternosTOBE_proceso,
          hojasImpresasASIS_proceso:infoProceso.hojasImpresasASIS_proceso,
          hojasImpresasTOBE_proceso:infoProceso.hojasImpresasTOBE_proceso,
          kmRecorridosASIS_Proceso:infoProceso.kmRecorridosASIS_Proceso,
          kmRecorridosTOBE_Proceso:infoProceso.kmRecorridosTOBE_Proceso
        })
      }
  });
}

//Método para recargar la tabla de procedimientos
recargarTabla(id:number)
{
  
}

//Método para abrir el cuadro de confirmación al eliminar un registro
openDialogConfirmaAsIs(id:number)
{
  let dialogRef = this.dialog.open(ConfirmComponent,{data: `¿Desea eliminar el registro?`,disableClose:true});
  dialogRef.afterClosed().subscribe(result => {
    if(result==false)
    {
      
    }
    else{
      //Eliminamos el registro de la tabla
      this.eliminarProcedimientoAsIs(id);
    }
 });
}


//Método para abrir el cuadro de confirmación al eliminar un registro
openDialogConfirmaToBe(id:number)
{
  let dialogRef = this.dialog.open(ConfirmComponent,{data: `¿Desea eliminar el registro?`,disableClose:true});
  dialogRef.afterClosed().subscribe(result => {
    if(result==false)
    {
      
    }
    else{
      //Eliminamos el registro de la tabla
      this.eliminarProcedimientoToBe(id);
    }
 });
}



}//Cierre de la clase